import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentOverlay = _resolveComponent("ContentOverlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      openTerms: $options.openTerms,
      agreed: $data.agreed
    }),
    _createVNode(_component_ContentOverlay, {
      modelValue: $data.termsModel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.termsModel) = $event)),
      "button-label": $props.buttonLabel,
      onCta: _cache[1] || (_cache[1] = ($event: any) => ($data.agreed = true))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "overlay")
      ]),
      _: 3
    }, 8, ["modelValue", "button-label"])
  ]))
}